export default __webpack_public_path__ + "/dist/images/2884570.df50f0db9ea91bd8e02ff0c5b53c12c8.png";